import type {
  Account,
  AccountAddress,
  AccountContact,
  AccountEconomicGroup,
} from '@/api/commercial/accounts';
import type {
  LocalAccount,
  LocalAccountEconomicGroup,
  LocalAddress,
  LocalContact,
} from '@/context/create-account-flow';

export const toLocalAccount = (account: Account): LocalAccount => ({
  id: account.id,
  document: account.document,
  name: account.name,
  rg: account.rg,
  social_name: account.social_name,
  fantasy_name: account.fantasy_name,
  state_registration: account.state_registration,
  municipal_registration: account.municipal_registration,
  status: account.status,
  situationIE: account.situationIE,
  typeIE: account.typeIE,
  setor: account.setor,
  accountType: account.accountType as LocalAccount['accountType'],
  simeiSince: account.simeiSince,
  natureText: account.natureText,
});

export const toLocalAddress = (address: AccountAddress): LocalAddress => ({
  id: address.id,
  accountId: address.accountId,
  city: address.city,
  state: address.state,
  street: address.street,
  district: address.district,
  number: address.number,
  zip_code: address.zip_code,
  complement: address.complement,
  reference_point: address.reference_point,
  type: address.type,
  default_address: address.default_address,
});

export const toLocalContact = (contact: AccountContact): LocalContact => ({
  id: contact.id,
  accountId: contact.accountId,
  name: contact.name,
  contractEnabled: contact.contractEnabled,
  positionOrRelation: contact.positionOrRelation,
  area: contact.area,
  cpf: contact.cpf,
  rg: contact.rg,
  taxId: contact.taxId,
  contactFor: contact.contactFor,
  contactItems: contact.contactItems,
  originType: contact.originType,
});

export const toLocalEconomicGroup = (
  group: AccountEconomicGroup | null,
): LocalAccountEconomicGroup | null => {
  if (!group) return null;
  return {
    economic_group_holding: group.economic_group_holding,
    economic_group_controlled: group.economic_group_controlled,
  };
};
